<template>
  <v-card>
    <v-card-text>
      <v-text-field
        v-model="name"
        label="Name"
        :error-messages="nameErrorMessages"
      />
      <v-checkbox
        v-model="automaticallyStopTimeTracking"
        label="Zeit automatisch stoppen"
      />
      <v-simple-table>
        <thead>
          <tr>
            <th class="text-center">Montag</th>
            <th class="text-center">Dienstag</th>
            <th class="text-center">Mittwoch</th>
            <th class="text-center">Donnerstag</th>
            <th class="text-center">Freitag</th>
            <th class="text-center">Samstag</th>
            <th class="text-center">Sonntag</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td valign="top"><day-hours v-model="monday" /></td>
            <td valign="top"><day-hours v-model="tuesday" /></td>
            <td valign="top"><day-hours v-model="wednesday" /></td>
            <td valign="top"><day-hours v-model="thursday" /></td>
            <td valign="top"><day-hours v-model="friday" /></td>
            <td valign="top"><day-hours v-model="saturday" /></td>
            <td valign="top"><day-hours v-model="sunday" /></td>
          </tr>
        </tbody>
      </v-simple-table>
    </v-card-text>
    <v-card-actions>
        <v-btn color="default" text @click="doCancel">Abbrechen</v-btn>
        <v-btn color="primary" @click="doConfirm" :disabled="!valid">Speichern</v-btn>
      </v-card-actions>
  </v-card>
</template>

<script>

import moment from 'moment';
import DayHours from './DayHours';

export default {
  name: 'TimeModel',
  props: {
    initialTimeModel: {
      type: Object,
    },
  },
  components: {
    DayHours,
  },
  watch: {
  },
  mounted() {
  },
  computed: {
    valid() {
      return this.isValid();
    },
    nameErrorMessages() {
      return !this.name ? 'Pflichfeld' : null;
    },
  },
  methods: {
    doCancel() {
      this.$emit('cancel');
    },
    doConfirm() {
      const data = {
        name: this.name,
        automaticallyStopTimeTracking: this.automaticallyStopTimeTracking,
        monday: this.monday.from && this.monday.to ? this.monday : null,
        tuesday: this.tuesday.from && this.tuesday.to ? this.tuesday : null,
        wednesday: this.wednesday.from && this.wednesday.to ? this.wednesday : null,
        thursday: this.thursday.from && this.thursday.to ? this.thursday : null,
        friday: this.friday.from && this.friday.to ? this.friday : null,
        saturday: this.saturday.from && this.saturday.to ? this.saturday : null,
        sunday: this.sunday.from && this.sunday.to ? this.sunday : null,
        utcOffset: moment().utcOffset() / 60,
      };
      this.$emit('save', data);
    },
    isValid() {
      return !this.nameErrorMessages;
    },
    createDefaultDayHours() {
      return {
        from: null,
        to: null,
        breaks: [],
      };
    }
  },
  data() {
    return {
      name: this.initialTimeModel ? this.initialTimeModel.name : '',
      automaticallyStopTimeTracking: this.initialTimeModel ? this.initialTimeModel.automaticallyStopTimeTracking : false,
      monday: this.initialTimeModel && this.initialTimeModel.monday ? this.initialTimeModel.monday : this.createDefaultDayHours(),
      tuesday: this.initialTimeModel && this.initialTimeModel.tuesday ? this.initialTimeModel.tuesday : this.createDefaultDayHours(),
      wednesday: this.initialTimeModel && this.initialTimeModel.wednesday ? this.initialTimeModel.wednesday : this.createDefaultDayHours(),
      thursday: this.initialTimeModel && this.initialTimeModel.thursday ? this.initialTimeModel.thursday : this.createDefaultDayHours(),
      friday: this.initialTimeModel && this.initialTimeModel.friday ? this.initialTimeModel.friday : this.createDefaultDayHours(),
      saturday: this.initialTimeModel && this.initialTimeModel.saturday ? this.initialTimeModel.saturday : this.createDefaultDayHours(),
      sunday: this.initialTimeModel && this.initialTimeModel.sunday ? this.initialTimeModel.sunday : this.createDefaultDayHours(),
    };
  },
};
</script>
